const hookURL = import.meta.env.VITE_SLACK_WEBHOOK_URL as string;

export const sendMessageToSlack = async (message: string) => {
  if (hookURL) {
    await fetch(hookURL, {
      method: 'POST',
      body: JSON.stringify({
        text: message,
      }),
    });
  }
};
